import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Chargebee connector can link customers, subscriptions, invoices, events, and more to PostHog.`}</p>
    <p>{`To link Chargebee:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the `}<a parentName="p" {...{
            "href": "https://us.posthog.com/pipeline/sources"
          }}>{`sources tab`}</a>{` of the data pipeline section in PostHog.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`+ New source`}</strong>{` and then click `}<strong parentName="p">{`Link`}</strong>{` next to Chargebee.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Next, you need an API key from Chargebee. To start, in your Chargebee dashboard click on `}<strong parentName="p">{`Settings`}</strong>{` in the sidebar. In the dropdown, select `}<strong parentName="p">{`Configure Chargebee`}</strong>{`. Next, scroll down and select `}<strong parentName="p">{`API keys`}</strong>{`. Here you should see a list of existing API keys. It is recommended to use a dedicated read-only key for this integration, so go to `}<strong parentName="p">{`+ Add API Key`}</strong>{` and select `}<strong parentName="p">{`Read-Only Key`}</strong>{`. Copy the value of the newly created key.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Back in PostHog, paste the API key in the `}<inlineCode parentName="p">{`API key`}</inlineCode>{` field.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will also need to provide your Chargebee's site name. You can find this in the top-left of your dashboard. It is also the same as the subdomain of your dashboard (i.e. the part before `}<inlineCode parentName="p">{`.chargebee.com`}</inlineCode>{`)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Once you've entered these 2 pieces of information, hit `}<strong parentName="p">{`Next`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the next page, set up the schemas you want to sync and modify the method and frequency as needed. Once done, click `}<strong parentName="p">{`Import`}</strong>{`.`}</p>
      </li>
    </ol>
    <p>{`Once the syncs are complete, you can start using Chargebee data in PostHog.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      